/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Benefit_Billing_DescInputs */

const en_home_benefit_billing_desc = /** @type {(inputs: Home_Benefit_Billing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When possible, we pay providers and hospitals directly so you can focus on recovery.`)
};

const fr_home_benefit_billing_desc = /** @type {(inputs: Home_Benefit_Billing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dans la mesure du possible, nous payons directement les prestataires et les hôpitaux pour que vous puissiez vous concentrer sur votre rétablissement.`)
};

/**
* | output |
* | --- |
* | "When possible, we pay providers and hospitals directly so you can focus on recovery." |
*
* @param {Home_Benefit_Billing_DescInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_benefit_billing_desc = /** @type {((inputs?: Home_Benefit_Billing_DescInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Benefit_Billing_DescInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_benefit_billing_desc(inputs)
	return fr_home_benefit_billing_desc(inputs)
});